import { animate, AnimationMetadata, style, transition } from '@angular/animations';

export const fadeInAnimation: AnimationMetadata[] = [
  transition(':enter', [style({ opacity: 0 }), animate('500ms ease-in-out', style({ opacity: 1 }))]),
];
